import { Deserializable } from '../protocols/deserializable';
import { RemittanceStatus } from './remittance-status';
import { RemittancePaymentStatus } from './remittance-payment-status';
import { ScheduledRemittanceStatus } from './scheduled-remittance-status';
import { RemittanceStatusPill } from '../shared/remittance-status-pill';
import { RemittancePaymentStatusPill } from '../shared/remittance-payment-status-pill';
import { ScheduledRemittanceStatusPill } from '../shared/scheduled-remittance-status-pill';
import * as moment from 'moment/moment';

export class ActiveRemittance implements Deserializable {
  public id!: number;
  public memberId!: number;
  public employerId!: number;
  public employerName!: string;
  public remittanceStatus!: RemittanceStatus | null;
  public remittancePaymentStatus!: RemittancePaymentStatus | null;
  public scheduledRemittanceName!: string | null;
  public scheduledRemittanceStatus!: ScheduledRemittanceStatus | null;
  public scheduledRemittanceEndDate!: string | null;

  // Not from API
  public formattedScheduledRemittanceEndDate?: string;
  public remittanceStatusPill?: RemittanceStatusPill;
  public remittancePaymentStatusPill?: RemittancePaymentStatusPill;
  public scheduledRemittanceStatusPill?: ScheduledRemittanceStatusPill;

  public onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;

    if (!!this.remittanceStatus) {
      this.remittanceStatus = Deserialize?.instanceOf(RemittanceStatus, this.remittanceStatus);
      this.remittanceStatusPill = new RemittanceStatusPill(this.remittanceStatus.id, this.remittanceStatus.name);
    }

    if (!!this.remittancePaymentStatus) {
      this.remittancePaymentStatus = Deserialize?.instanceOf(RemittancePaymentStatus, this.remittancePaymentStatus);
      this.remittancePaymentStatusPill = new RemittancePaymentStatusPill(
        this.remittancePaymentStatus.id,
        this.remittancePaymentStatus.name
      );
    }

    if (!!this.scheduledRemittanceStatus) {
      this.scheduledRemittanceStatusPill = new ScheduledRemittanceStatusPill(
        this.scheduledRemittanceStatus.id,
        this.scheduledRemittanceStatus.name
      );
      this.formattedScheduledRemittanceEndDate = moment(this.formattedScheduledRemittanceEndDate).format('MMM D, yyyy');
    }
  }
}
